export default __webpack_public_path__ + "static/media/zero_proof.5ecbde19.png";